export default "__VITE_ASSET__DVlrI9za__"